// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-1qRE8y_k","box":"box-22a61_pk","footer":"footer-2nssEL_M"};